import { render, staticRenderFns } from "./PsConfigurationAccounts.vue?vue&type=template&id=7a83c793&scoped=true&"
import script from "./PsConfigurationAccounts.vue?vue&type=script&lang=js&"
export * from "./PsConfigurationAccounts.vue?vue&type=script&lang=js&"
import style0 from "./PsConfigurationAccounts.vue?vue&type=style&index=0&id=7a83c793&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a83c793",
  null
  
)

export default component.exports